import React from "react";
import Shell from "../../../common/components/Shell/Shell";
import { Grid } from "@mui/material";
import DTOComplaints from "./DTOComplaints";
import { useTranslation } from "react-i18next";
import ComplaintsPresenter from "./ComplaintsPresenter";

function ComplaintsController() {
  const { t, i18n } = useTranslation();

  return (
    <Shell>
      <Grid
        container
        style={{
          maxWidth: "auto",
          marginLeft: i18n.language == "en" ? "7.25em" : "",
        }}
      >
        <DTOComplaints />
        <ComplaintsPresenter trans={t} i18n={i18n} />
      </Grid>
    </Shell>
  );
}
export default ComplaintsController;
